import { z } from "zod";
/** Every permission in the system. The server checks these on every protected route. */
export const PERMISSIONS = [
    "users.manage",
    "integrations.manage",
    "settings.manage",
    "audit.view",
    "search.run",
    "listings.view",
    "listings.refresh",
    "listings.capture_manual",
    "catalog.manage",
    "research.create",
    "research.update_own",
    "research.update_any",
    "research.submit",
    "research.approve",
    "purchases.record",
    "holdings.view",
    "holdings.update",
    "grading.manage",
    "sales.record",
    "portfolio.view_costs",
    "portfolio.view_values",
    "portfolio.view_analytics",
];
export const PermissionSchema = z.enum(PERMISSIONS);
export const ROLES = ["admin", "employee"];
export const RoleSchema = z.enum(ROLES);
/** Card search is for admins for now (D-64); an admin can still grant it to an employee. */
const EMPLOYEE_DEFAULTS = [
    "listings.view",
    "listings.refresh",
    "listings.capture_manual",
    "research.create",
    "research.update_own",
    "research.submit",
    "purchases.record",
    "holdings.view",
    "holdings.update",
    "grading.manage",
    "sales.record",
];
/** Default permissions per role (docs, section 10.2). Admins have everything. */
export const ROLE_PERMISSIONS = {
    admin: PERMISSIONS,
    employee: EMPLOYEE_DEFAULTS,
};
/** Extra permissions an admin may grant to an individual employee. Approving purchases is never grantable. */
export const GRANTABLE_PERMISSIONS = [
    "search.run",
    "research.update_any",
    "catalog.manage",
    "portfolio.view_costs",
    "portfolio.view_values",
    "portfolio.view_analytics",
];
export const GrantablePermissionSchema = z.enum(GRANTABLE_PERMISSIONS);
export const isGrantable = (permission) => GRANTABLE_PERMISSIONS.includes(permission);
/**
 * Effective permissions = role defaults + individual grants.
 * Grants that are not grantable are ignored, so a bad database row can never escalate access.
 * The result is sorted and free of duplicates.
 */
export function resolvePermissions(role, grants = []) {
    const effective = new Set(ROLE_PERMISSIONS[role]);
    for (const grant of grants) {
        if (isGrantable(grant))
            effective.add(grant);
    }
    return PERMISSIONS.filter((p) => effective.has(p));
}
export const hasPermission = (permissions, required) => permissions.includes(required);
//# sourceMappingURL=permissions.js.map